(function FAQ(SectionsDesign) {
  'use strict';

  if (SectionsDesign.faq) return;
  SectionsDesign.faq = {};

  var support = getSupport();

  var init = function() {
    var configNodes = Array.from(document.querySelectorAll('[data-faq-config]'));

    configNodes.map(configNode => {
      var section = compose(publicAPI, setEvents, getBlocks, getConfig)(configNode);
      SectionsDesign.faq[section.id] = section;
    });
  }

  init();

  function publicAPI(config) {
    return {
      id: config.sectionId,
      config: config,
      blocks: zipObj(config.blockIds, config.blocks),
      init: init
    };
  }

  //**************************

  function blockEvents(block) {
    if (!block || !block.trigger) return block;

    if (block.trigger.hasAttribute('data-faq-init')) return block;

    block.trigger.setAttribute('data-faq-init', true);
    block.trigger.addEventListener('click', triggerClick);

    function triggerClick() {
      toggle(block);
    }

    return block;
  }

  function toggle(block) {
    block.collapsed ? expand(block) : collapse(block);
    return block;
  }

  function expand(block) {
    block.button.setAttribute('aria-expanded', true);
    block.panel.removeAttribute('hidden');
    animate(block.panel, 'normal');
    return block;
  }

  function collapse(block) {
    block.button.setAttribute('aria-expanded', false);
    block.panel.setAttribute('hidden', '');
    animate(block.panel, 'reverse');
    return block;
  }

  function isCollapsed(block) {
    return Boolean(block.button.getAttribute('aria-expanded') === 'false');
  }

  function animate(element, direction) {
    if (!support.WebAnimations) return;

    element.setAttribute('data-is-animating', true);

    element.animate([
      { height: 0 },
      { height: element.offsetHeight + 'px' }
    ], {
      duration: 240,
      fill: 'both',
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      direction: direction
    }).onfinish = function() {
      element.removeAttribute('data-is-animating');
      this.cancel();
    };
  }

  //**************************

  function getBlocks(config) {
    const sectionNode = document.querySelector('#shopify-section-' + config.sectionId);
    config.blocks = config.blockIds
      .map(blockId => block(blockId, sectionNode))
      .filter(b => b); // skip nulls
    return config;
  }
 
  function block(blockId, sectionNode) {
    const trigger = sectionNode.querySelector('[data-faq-trigger="' + blockId + '"]');
    const button = sectionNode.querySelector('[data-faq-button="' + blockId + '"]');
    const panel = sectionNode.querySelector('[data-faq-panel="' + blockId + '"]');

    if (!trigger || !button || !panel) return null;

    return {
      trigger: trigger,
      button: button,
      panel: panel,

      get collapsed() { return isCollapsed(this) },
      select: function select() { return expand(this) },
      deselect: function deselect() { return collapse(this) }
    };
  }

  function setEvents(config) {
    config.blocks.forEach(blockEvents);
    return config;
  }

  function getConfig(node) {
    return JSON.parse(node.innerHTML);
  }

  function getSupport() {
    return {
      WebAnimations: (typeof Element.prototype.animate === 'function')
    };
  }

  //**************************

  function zipObj(keys, values) {
    return keys.reduce(function zipObj(acc, key, idx) {
      acc[key] = values[idx];
      return acc;
    }, {});
  }

  function compose() {
    var funcs = Array.prototype.slice.call(arguments).reverse();
    return function() {
      return funcs.slice(1).reduce(function(res, fn) {
        return fn(res);
      }, funcs[0].apply(undefined, arguments));
    };
  }

})(window.SectionsDesign = window.SectionsDesign || {});
